import React from 'react';
import { RevealText } from './RevealText';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="px-4 md:px-8 py-12 md:py-20 border-b border-ink/20" data-id="element-72">
      <div className="max-w-7xl mx-auto" data-id="element-73">
        <div className="flex items-center gap-4 mb-8" data-id="element-74">
          <span className="w-12 h-px bg-vermillion" data-id="element-75" />
          <span className="font-sans text-xs font-bold tracking-kicker text-vermillion uppercase" data-id="element-76">
            כתבת השער
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16" data-id="element-77">
          <div className="lg:col-span-8" data-id="element-78">
            <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl font-black leading-[0.9] text-ink mb-10" data-id="element-79">
              <RevealText text="המילים שמעצבות את הדור הבא" data-id="element-80" />
            </h2>

            <div className="editorial-columns font-sans text-lg md:text-xl leading-relaxed text-ink-soft" data-id="element-81">
              <p className="dropcap mb-6" data-id="element-82">
                בעידן שבו השפה משתנה בקצב מסחרר, אנחנו מוצאים את עצמנו מחפשים
                משמעות חדשה במילים ישנות. הטכנולוגיה אולי מאיצה את התקשורת, אבל
                היא גם דורשת מאיתנו לבחון מחדש את האופן שבו אנחנו מתבטאים,
                חושבים ומרגישים.
              </p>
              <p className="mb-6" data-id="element-83">
                הדור החדש של כותבים, הוגים ויוצרים לא מסתפק בהגדרות הקיימות. הם
                מפרקים את השפה לגורמים ומרכיבים אותה מחדש, יוצרים תחביר שמשקף
                מציאות מורכבת, רבודה ורב-ממדית.
              </p>
              <p data-id="element-84">
                במאמר זה נצלול לעומק התמורות שחלות בשפה העברית, נבחן כיצד רשתות
                חברתיות משפיעות על מבנה המשפט, ואיך כל זה קשור לזהות המקומית
                שלנו כאן ועכשיו.
              </p>
            </div>

            <div className="mt-10 flex items-center gap-4 font-sans text-sm" data-id="element-85">
              <div className="w-10 h-10 rounded-full bg-ink/10 overflow-hidden" data-id="element-86">
                <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=100&auto=format&fit=crop" alt="Author" className="w-full h-full object-cover grayscale" data-id="element-87" />
              </div>
              <div data-id="element-88">
                <div className="font-bold text-ink" data-id="element-89">מאת: שירה לוי</div>
                <div className="text-ink-soft/70" data-id="element-90">זמן קריאה: 12 דקות</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col justify-center" data-id="element-91">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="aspect-[3/4] w-full relative overflow-hidden bg-ink" data-id="element-92">
              <div className="absolute inset-0 bg-gradient-to-tr from-vermillion/80 to-transparent mix-blend-multiply z-10" data-id="element-93" />
              <img src="https://images.unsplash.com/photo-1455390582262-044cdead2708?q=80&w=800&auto=format&fit=crop" alt="Editorial abstract" className="w-full h-full object-cover grayscale contrast-125" data-id="element-94" />
              <div className="absolute bottom-0 left-0 right-0 p-6 z-20 bg-gradient-to-t from-ink to-transparent" data-id="element-95">
                <div className="font-serif text-paper text-xl" data-id="element-96">
                  ״השפה היא הבית של ההוויה״
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}